<template>

  <v-container fluid fill-height pa-0>

    <v-layout column fill-height ma-0 pa-0>

      <v-layout fill-height column  ma-0 pt-0>
        
        <scroll-area>
          
          <template slot="body">

            <v-layout style="height: 40px" px-0 pt-3 pb-2>
              <v-layout fill-height class="title">
                <v-layout align-center justify-start px-0>
                  <span class="body-2">{{ $t('Импорт CA (P12)') }}</span>
                </v-layout>
              </v-layout>
            </v-layout>

            <v-layout shrink>
              <v-layout fill-height justify-start>
                <v-flex xs7 pa-0>
                  <v-layout fill-height justify-start>
                    <v-flex xs3 pa-0>
                      <v-tooltip dark color="secondary" right>
                        <v-btn block small slot="activator" color="accent"
                        :disabled="!model.pass"
                        :data-testid="$options.name + '__btn__' + 'upload_p12'">
                        <v-layout fill-height justify-start align-center py-1>
                            <v-flex shrink pr-1 pt-1>
                              <svg-icon
                                color="white"
                                :name="'certificate_import'"
                                width="20"
                              />
                            </v-flex>
                              <span>{{$t('import sertificate (CA)')}}</span>
                          </v-layout>
                          <input accept 
                            ref="file-input" 
                            class="button-file-upload__input" 
                            type="file" 
                            title=" "
                            :data-testid="$options.name + '__input__' + 'file-input_p12'"
                            @change="(e) => onFileAdd(e, 'stream')" >
                        </v-btn>
                        <span>{{ $t('import sertificate (CA)') }}</span>
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-layout>

            <v-layout mb-2 mt-2 px-0>
              <v-layout class="title toolbar_castom" style="height: 50px; background-color: #FBDCCA" >
                <v-flex shrink pl-2>
                  <svg-icon
                    color="secondary"
                    :name="'undefined'"
                    width="34"
                  />
                </v-flex>
                <v-layout column fill-height>
                  <v-layout align-end justify-start px-2>
                    <span class="body-2">{{ $t('Создание нового сертификата') }}</span>
                  </v-layout>
                  <v-layout align-start justify-start px-2>
                    <span class="caption secondary--text">{{ $t('Приведет к замене корневого сертификата системы') }}</span>
                  </v-layout>
                </v-layout>                
              </v-layout>
              <v-flex xs6 ></v-flex>
            </v-layout>

            <v-layout shrink justify-start mb-3 >
              <v-layout column  justify-start >
                <v-layout column shrink pt-2>

                  <v-layout fill-height justify-start pr-1 pb-1>
                    <v-flex xs7  pa-0>
                      <v-text-field    
                        :value="$t('password')"                 
                        light
                        outline
                        flat
                        readonly
                        class="backgrey"
                        hide-details
                        :rows="1"
                        color="white"
                      >                   
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12  pa-0>                          
                      <v-text-field
                        :data-testid="$options.name + '__text-field__' + 'pass'"
                        v-model="model.pass"
                        light
                        outline
                        flat
                        class="white"
                        hide-details
                        :rows="1"
                        color="accent"
                      >                     
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout align-start justify-start pl-1>
                    <span class="caption secondary--text">{{ $t('Пароль используется для расшифровки закрытого ключа в файле P12') }}</span>
                  </v-layout>

                </v-layout>

              </v-layout>
              
              <v-flex xs6></v-flex>
            </v-layout>

          </template>

        </scroll-area>

      </v-layout>

    </v-layout>

  </v-container>

</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import svgIcon from '@/nms/components/media/svg/static/svg-icon.vue'
import { $_localhost } from '@/nms/plugins/bridge.js'

// Типы
interface CustomFile extends File {
  data?: {
    hash?: string
    description?: string
    callback?: {
      progress?: (item: any, progress: any) => void
      success?: (item: any, response: any) => void
      warning?: (item: any, message: string) => void
      error?: (item: any, message: string) => void
    }
  }
  [key: string]: any
}

interface ModelData {
  pass: string | null
}

interface CurrentState {
  files: CustomFile[]
  update: string[]
}

interface UploadProgress {
  loaded: number
  [key: string]: any
}

export default Vue.extend({
  name: 'SERTIFICATES-IMPORT',

  components: {
    scrollArea,
    svgIcon,
  },

  props: {},

  data(): {
    clear: boolean
    meta: any | null
    data: any | null
    model: ModelData
    current: CurrentState
  } {
    return {
      clear: false,
      meta: null,
      data: null,
      model: {
        pass: null,
      },
      current: {
        files: [],
        update: []
      },
    }
  },

  created(): void {
    this.setup()
  },

  methods: {
    async setup(): Promise<void> {
      // Метод предназначен для переопределения при необходимости
    },

    setLoader(name: string, status: boolean): void {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })
    },

    async mapFiles(): Promise<CustomFile[]> {
      const mFiles: CustomFile[] = []

      this.current.files.forEach(item => {
        if (!item.data) {
          item.data = {}
        }
        item.data.callback = {
          progress: (fileItem: CustomFile, progress: UploadProgress) => {
            console.log('TOAST ITEM', fileItem, progress)
            if (progress.loaded < 1000000) return

            const toast = this.$snotify.get('toast-' + fileItem.name)

            if (!toast) {
              this.$snotify.html(
                '<div class="fit"><span class="text-truncate block">' + fileItem.name + '</span></div>' +
                '<div class="caption fit"><span id="toast-progress-text-' + fileItem.name + '" class="text-truncate block">Файл загружен на <span id="toast-progress-value-' + fileItem.name + '">' + progress.loaded + '</span>%</span></div>' +
                '<div role="progressbar" aria-valuemin="0" aria-valuemax="100" class="v-progress-linear mb-0" style="height: 4px;">' +
                '<div class="v-progress-linear__background primary" style="height: 4px; opacity: 0.3; width: 100%;"></div>' +
                '<div class="v-progress-linear__bar">' +
                '<div id="toast-progress-bar-' + fileItem.name + '-determinate" class="v-progress-linear__bar__determinate accent" style="width: ' + progress.loaded + '%;"></div>' +
                '<div id="toast-progress-bar-' + fileItem.name + '-indeterminate" style="display: none" class="v-progress-linear__bar__indeterminate v-progress-linear__bar__indeterminate--active"><div class="v-progress-linear__bar__indeterminate long primary"></div><div class="v-progress-linear__bar__indeterminate short primary"></div></div>' +
                '<div id="toast-progress-bar-' + fileItem.name + '-success" style="display: none" class="v-progress-linear__bar__determinate success" style="width: ' + progress.loaded + '%;"></div>' +
                '</div>' +
                '</div>',
                {
                  id: 'toast-' + fileItem.name,
                  timeout: 0,
                  closeOnClick: true,
                  pauseOnHover: false,
                }
              )
            } else {
              const determinateBar = document.getElementById('toast-progress-bar-' + fileItem.name + '-determinate')
              const valueSpan = document.getElementById('toast-progress-value-' + fileItem.name)
              if (determinateBar) {
                determinateBar.style.width = progress.loaded + '%'
              }
              if (valueSpan) {
                valueSpan.innerText = String(progress.loaded)
              }
              if (progress.loaded === 100) {
                this.$snotify.remove('toast-' + fileItem.name)
              }
            }
          },

          success: (fileItem: CustomFile, response: any) => {
            this.$snotify.html(
              '<div class="fit"><span class="text-truncate block">' + fileItem.name + '</span></div>' +
              '<div class="caption fit"><span id="toast-progress-text-' + fileItem.name + '" class="text-truncate block">Файл загружен на <span id="toast-progress-value-' + fileItem.name + '"></span>100%</span></div>' +
              '<div role="progressbar" aria-valuemin="0" aria-valuemax="100" class="v-progress-linear mb-0" style="height: 4px;">' +
              '<div class="v-progress-linear__background green" style="height: 4px; opacity: 1; width: 100%;"></div>' +
              '<div class="v-progress-linear__bar">' +
              '<div id="toast-progress-bar-' + fileItem.name + '-success" style="display: none" class="v-progress-linear__bar__determinate success" style="width: 100%;"></div>' +
              '</div>' +
              '</div>',
              {
                id: 'toast-success' + fileItem.name,
                timeout: 2000,
                showProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
              }
            )
            setTimeout(() => this.$snotify.remove('toast-' + fileItem.name), 0)
            setTimeout(() => this.$snotify.remove('toast-success' + fileItem.name), 2000)
          },

          warning: (fileItem: CustomFile, message: string) => {
            console.log('upload fail', fileItem, message)
          },

          error: (fileItem: CustomFile, message: string) => {
            console.log('upload fail', fileItem, message)
            this.$snotify.error('Внимание! Файл ' + fileItem.name + ' НЕ загружен!', {
              timeout: 2000,
              showProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
            })
          },
        }
        mFiles.push(item)
      })

      return mFiles
    },

    async onFileAdd(e: any, type: string): Promise<void> {
      console.log(this.$options.name, 'onFileAdd', 'e', e.target.files)
      console.log(this.$options.name, 'onFileAdd', 'type', type)

      if (!e.target.files?.length) return

      this.clear = true
      this.$nextTick(() => {
        this.clear = false
      })

      const uploadMethod = (files: CustomFile[]) => {
        if (type === 'cmdb') {
          files.forEach(file => this.fileUpload(file))
        }
        if (type === 'stream') {
          files.forEach(file => this.fileStreamUpload(file))
        }
      }

      const files = Array.from(e.target.files) as CustomFile[]

      for (const file of files) {
        const hash = await this.generateFileHash(file)
        if (!this.current.files.find(item => item.data?.hash === hash)) {
          file.data = {
            hash: hash,
            description: '',
          }
          this.current.files.push(file)
        } else {
          this.$snotify.warning(`Внимание! Файл ${file.name} уже загружен!`, {
            timeout: 2000,
            showProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
          })
        }
      }

      const mappedFiles = await this.mapFiles()
      uploadMethod(mappedFiles)
    },

    async fileStreamUpload(payload: CustomFile): Promise<any> {
      console.log(this.$options.name, 'fileStreamUpload', 'payload', payload)
      try {
        const result = await this.$store.dispatch('file/upload/execute', {
          filetype: payload.type,
          $id: null,
          list: [payload],
          vm: this,
          method: 'arrayBuffer',
          params: {
            type: 'certificate',
            password: '12345'
          }
        })
        console.log(this.$options.name, 'fileStreamUpload', 'result', result)
        return result
      } catch (error) {
        console.error('CATCH', this.$options.name, 'fileStreamUpload', error)
        throw error
      }
    },

    async fileUpload(payload: CustomFile): Promise<Response> {
      console.log(this.$options.name, 'fileUpload', 'payload', payload)
      const host = $_localhost ? 'http://192.168.2.69' : window.location.origin
      const fileName = payload.name || ''

      try {
        const formData = new FormData()
        formData.append('type', 'file')
        formData.append('files', payload)

        const response = await fetch(host + '/e-cluster/filemanager/files', {
          method: 'POST',
          body: formData,
        })

        if (response.ok) {
          this.$dialog.notify.success(`Файл "${fileName}" успешно загружен`, { timeout: 5000 })
          return response
        } else {
          this.$dialog.notify.error(`Ошибка загрузки файла "${fileName}": ${response.statusText}`, { timeout: 5000 })
          throw new Error(`HTTP error ${response.status}: ${response.statusText}`)
        }
      } catch (error) {
        console.error('CATCH', this.$options.name, 'fileUpload', error)
        throw error
      }
    },

    async generateFileHash(file: CustomFile): Promise<string> {
      try {
        const fileInfo = `${file.name}${file.lastModified}${file.size}${file.type}`
        const encoder = new TextEncoder()
        const data = encoder.encode(fileInfo)
        const hash = await crypto.subtle.digest('SHA-256', data)
        return Array.from(new Uint8Array(hash))
          .map(b => b.toString(16).padStart(2, '0'))
          .join('')
      } catch (error: any) {
        throw new Error(`Ошибка генерации хеша: ${error.message}`)
      }
    },

    reset(): void {
      this.model = {
        pass: null
      }
    },
  },
})
</script>

<style lang="css" scoped>
.toolbar_castom {
    border: solid 1px #9F9F9F ;
    border-radius: 2px;
    /* background-color: #D4EEFC */
  }
</style>

<style lang="stylus" scoped>

    .button-file-upload

        position: relative
        box-sizing: border-box

        &_extension

            &_blank

                padding-left: 0;
                border-color: transparent

            &_new

                padding-left: 0;
                border-color: transparent

        &__area

            display: flex
            justify-content: center

            width: 80px
            height: 80px

            border-radius: 50%
            border: 1px solid alpha(#000, .4)

        &__control

            position: relative
            overflow: hidden
            z-index: 2

            cursor: pointer

            &.fiv-icon-blank

                opacity: .4
                transition: opacity .4s

                &:hover

                    opacity: 1

            &.fiv-icon-new

                opacity: .4
                transition: opacity .4s

                &:hover

                    opacity: 1

        &__overlay

            position: absolute

            top: 0
            right: 0
            bottom: 0
            left: 0

            margin-right: -8px

            width: 100%
            /* height */

            background: alpha(#fff, .9)

            opacity: 0
            transition: opacity .4s

            &:hover

                opacity: 1

        &__delete

            cursor: pointer

            margin-right: -16px
            margin-top: -16px

            opacity: .5
            transition: opacity .4s

            &:hover

                opacity: 1

        &__input

            display: block
            position: absolute

            top: 0
            right: 0

            width: 100%
            height: 100%
            /* min-width: 100%
            min-height: 100% */

            text-align: right

            opacity: 0
            outline: none
            cursor: inherit

        &__name

            display: block /* Fallback for non-webkit */
            max-height: calc(20px * 2) /* Fallback for non-webkit */
            min-height: calc(20px * 2) /* Fallback for non-webkit */
            margin: 0 auto
            font-size: 12px
            line-height: 16px
            -webkit-line-clamp: 3
            -webkit-box-orient: vertical
            overflow: hidden
            text-overflow: ellipsis
            word-break: break-all
            text-align: center;


</style>
